export enum WhatIfExtractMode{
    DONE = "DONE",
    ERRORS = "ERRORS",
    BOTH = "BOTH"
}